// This is an incomplete/imperfect implementation of a masked phone number input.
// As described at https://github.com/hungryinc/twotrees-325-kent/issues/40, such
// functionality is actually really hard to get right, and even the
// implementations with full-blown mask-handling logic engines have pretty
// serious bugs (see, e.g., https://github.com/text-mask/text-mask/issues/218,
// https://github.com/text-mask/text-mask/issues/483, and the entirety of
// https://github.com/insin/react-maskedinput/issues). In my search, I couldn't
// find any perfect implementation.
import React from 'react';
import { formatPhoneNumber, stripPhoneNumber } from '../../utility/utility';

export default class PhoneNumberInput extends React.Component {
  state = {
    // If the user just pressed the delete key at the end of the input,
    // we need to track that, as it effects how we update the input's value.
    isDeletingEnd: false
  }

  // proxy focus, blur to underlying input
  focus() {
    this.refs.input.focus();
  }

  blur() {
    this.refs.input.blur();
  }

  render() {
    return (
      <input
        ref='input'
        {...this.props}
        type='text'
        value={formatPhoneNumber(
          this.props.value,
          {omitEndingDelimiter: this.state.isDeletingEnd}
        )}
        onChange={e => {
          const lastPhoneNumberFormatted =
            formatPhoneNumber(this.props.value);

          const newCleanedValue = stripPhoneNumber(e.target.value);

          this.setState({
            isDeletingEnd: lastPhoneNumberFormatted.slice(0, -1) === e.target.value
          }, () => {
            typeof this.props.onChange === 'function' &&
              this.props.onChange(newCleanedValue);
          });
        }} />
    );
  }
}


// WEBPACK FOOTER //
// ./client/components/PhoneNumberInput/index.js